<template>
  <MenuRef :iShow="showColor">
    <div class="record">
      <div class="search-cond">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">单号查询:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.num" />
          </div>
          <div class="search-item">
            <div class="tol-title">企业名称:</div>
            <a-select show-search :allowClear="true" :filterOption="filterOption" v-model="form.companyId"
              class="Select-style" dropdownClassName="dropdown_style" @select="companySearchSelect"
              style="width: 434px; height: 40px; flex: 1 1 0%">
              <a-select-option v-for="item in companyList" :value="item.id" :key="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-item">
            <div class="tol-title">选择日期:</div>
            <a-config-provider :locale="locale">
              <a-range-picker :format="dateFormatList" dropdownClassName="time-style" v-model="timePicker"
                @change="getStartDatePicker" @clear="onDateClear" /></a-config-provider>
          </div>
        </div>
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">业务（负责人）:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.two" />
          </div>
          <div class="search-item">
            <div class="tol-title">电销（负责人）:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.three" />
          </div>
          <div class="search-item">
            <div class="tol-title">签收状态:</div>
            <a-select v-model="form.five" placeholder="请选择"  :allowClear="true">
              <a-select-option :value="1">未签收</a-select-option>
              <a-select-option :value="3">已签收</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">承运公司:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.six" />
          </div>
          <div class="search-item">
            <div class="tol-title">承运单号查询:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.generalCarrierNumber" />
          </div>
          <div class="search-item">
            <div class="tol-title">运作人员:</div>
            <a-select show-search :filterOption="filterOption" :allowClear="true" v-model="form.operationPersonnel"
              class="Select-style" dropdownClassName="dropdown_style" >
              <a-select-option v-for="item in operationUserList" :value="item.name" :key="item.name">{{ item.name}}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="search-input">
          <div class="search-item"></div>
          <div class="search-item"></div>
          <div class="search-item" style="justify-content: flex-end">
            <div class="btn-cond">
              <a-button @click="reset" class="search-normal"> 重置 </a-button>
              <a-button class="search-btn" :style="{ marginLeft: '24px' }" @click="searchData">
                查询
              </a-button>
            </div>
          </div>
        </div>
      </div>
      <div class="record-box">
        <div class="record-view">
          <div class="tol-item">
            <div>
              <a-button class="search-btn" @click="showDrawer(1)" v-if="permissions.waybillManagement.canAdd">
                新增
              </a-button>
              <a-button v-else type="primary" disabled> 新增 </a-button>
            </div>
            <div>
              <a-button :style="{
                marginLeft: '16px',
              }" class="search-normal" @click="exportData" v-if="permissions.waybillManagement.canExport">
                导出
              </a-button>
              <a-button :style="{
                marginLeft: '16px',
              }" v-else type="primary" disabled>
                导出
              </a-button>
            </div>
            <!--  <a-button
              :style="{ marginLeft: '16px' }"
              class="search-normal"
              @click=""
            >
              导入
            </a-button> -->
            <div>
              <a-button :style="{ marginLeft: '16px' }" class="search-delete" @click="deleteData"
                v-if="permissions.waybillManagement.canDeleteWaybill">
                删除
              </a-button>
              <a-button :style="{
                marginLeft: '16px',
              }" v-else type="primary" disabled>
                删除
              </a-button>
            </div>
          </div>
        </div>
        <div class="record-table" ref="tableContainer">
          <a-config-provider :locale="locale">
            <a-table :customRow="customRow" class="record-table" ref="table" size="small" :scroll="{ x: 2500 }"
              :rowSelection="rowSelection" :columns="columns" :data-source="tolInformation"
              :rowKey="(record, index) => index" :pagination="pagination"></a-table>
          </a-config-provider>
        </div>
      </div>
      <a-drawer :style="{ zIndex: 1 }" title="运单录入（小程序联单）" :width="1032" :visible="visible"
        :body-style="{ paddingBottom: '80px' }" @close="onClose">
        <a-spin :spinning="loading" tip="数据保存中...">
          <a-form :form="formData" layout="vertical">
            <a-row :gutter="24" v-show="vShow">
              <!-- 单号查询 -->
              <a-col :span="15">
                <a-form-item label="单号查询：" name="waybill">
                  <a-input v-model="formData.waybill" />
                  <a-button class="search-normal" @click="openList" style="
                      margin-left: 16px;
                      width: 108px;
                      height: 40px;
                      border-radius: 4px;
                      border: 1px solid #14cc76;
                      font-size: 16px;
                      color: #14cc76;
                    ">查看电子单</a-button>
                </a-form-item>
              </a-col>
              <a-col :span="9"></a-col>
            </a-row>
            <hr v-show="vShow" style="
                border: none;
                border-top: 2px dotted #e6e6e6;
                margin-bottom: 24px;
              " />
            <a-row :gutter="24">
              <!-- 客户企业 -->
              <a-col :span="12">
                <a-form-item label="客户企业：" name="companyId">
                  <a-select show-search :allowClear="true" :filterOption="filterOption" v-model="formData.companyId"
                    @select="companySelect" style="width: 434px; height: 40px; flex: 1 1 0%">
                    <a-select-option v-for="item in companyList" :value="item.id" :key="item.id">{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- 客户人员 -->
              <a-col :span="12">
                <a-form-item label="客户人员：" name="userId">
                  <div style="display: flex; flex-direction: column">
                    <a-select show-search :allowClear="true" :filterOption="filterOption" v-model="formData.userId"
                      class="Select-style" dropdownClassName="dropdown_style" @select="userSelect"
                      style="width: 434px; height: 40px; flex: 1 1 0%" :disabled="!formData.companyId">
                      <a-select-option v-for="item in userList" :value="item.id" :key="item.id">{{ item.nickname }}
                      </a-select-option>
                    </a-select>
                    <a-alert v-if="userList.length === 0 && formData.companyId" type="error" message="该企业无用户，请先到客户管理添加！"
                      show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <!-- 客户等级 -->
              <a-col :span="12">
                <a-form-item label="客户等级：" name="clientLevel">
                  <a-input v-model="formData.clientLevel" />
                </a-form-item>
              </a-col>
              <!-- 客户折扣 -->
              <a-col :span="12">
                <a-form-item label="客户折扣：" name="discount">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.discount" @change="validateNumber('discount', 'discountAlert')" />
                    <a-alert v-if="alerts.discountAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <!-- 电销人员 -->
              <a-col :span="12">
                <a-form-item label="电销人员：" name="telemarketingStaf">
                  <a-input v-model="formData.telemarketingStaf" />
                </a-form-item>
              </a-col>
              <!-- 联系方式 -->
              <!-- <a-col :span="12">
                <a-form-item label="联系方式：" name="phone">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.phone" @change="validateContact('phone')" />
                    <a-alert v-if="phoneAlerts.phone" type="error" message="请输入正确的手机号码或电话号码！" show-icon />
                  </div>
                </a-form-item>
              </a-col> -->
            </a-row>
            <hr style="
                border: none;
                border-top: 2px dotted #e6e6e6;
                margin-bottom: 24px;
              " />

            <a-row :gutter="24">
              <!-- 收货人 -->
              <a-col :span="12">
                <a-form-item label="寄件人：" name="sendName">
                  <a-input v-model="formData.sendName" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="联系方式：" name="sendPhone">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.sendPhone" @change="validateContact('sendPhone')" />
                    <a-alert v-if="phoneAlerts.sendPhone" type="error" message="请输入正确的手机号码或电话号码！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 寄件地址 -->
              <a-col :span="24">
                <a-form-item label="寄件地址：" name="sendAddressAll">
                  <div style="display: flex; flex-direction: column">
                    <a-cascader v-model="formData.sendAddressAll" :options="addressSendOptions"
                      :show-search="{ filter }" placeholder="请选择" @change="handleSendAddressChange" />
                    <a-alert v-if="saddStatus" type="error" :message="`请填写寄件地址!`" show-icon />
                  </div>
                  <a-input style="margin-left: 16px; width: 481px !important" placeholder="请输入详细地址"
                    v-model="formData.sendAddress" />
                  <a-button class="search-normal" style="
                      margin-left: 16px;
                      width: 80px;
                      height: 40px;
                      border-radius: 4px;
                      border: 1px solid #14cc76;
                      font-size: 16px;
                      color: #14cc76;
                      display: none;
                      align-items: center;
                      justify-content: center;
                    ">历史地址</a-button>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 收货人 -->
              <a-col :span="12">
                <a-form-item label="收货人：" name="receiveName">
                  <a-input v-model="formData.receiveName" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="联系方式：" name="receivePhone">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.receivePhone" @change="validateContact('receivePhone')" />
                    <a-alert v-if="phoneAlerts.receivePhone" type="error" message="请输入正确的手机号码或电话号码！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-item label="收货地址：" name="receiveAddressAll">
                  <div style="display: flex; flex-direction: column">
                    <a-cascader v-model="formData.receiveAddressAll" :options="addressOptions" placeholder="请选择"
                      :show-search="{ filter }" @change="handleReceiveAddressChange" />
                    <a-alert v-if="raddStatus" type="error" :message="`请填写收货地址!`" show-icon />
                  </div>
                  <a-input style="margin-left: 16px; width: 481px !important" placeholder="请输入详细地址"
                    v-model="formData.receiveAddress" />
                  <span class="search-normal" style="
                      margin-left: 16px;
                      width: 80px;
                      height: 40px;
                      border-radius: 4px;
                      border: 1px solid #14cc76;
                      font-size: 16px;
                      color: #14cc76;
                      display: none;
                      align-items: center;
                      justify-content: center;
                    ">历史地址</span>
                </a-form-item>
              </a-col>
            </a-row>
            <hr style="
                border: none;
                border-top: 2px dotted #e6e6e6;
                margin-bottom: 24px;
              " />
            <a-row :gutter="24">
              <!-- 运输类型 -->
              <a-col :span="19">
                <a-form-item label="运输类型：" name="method">
                  <div class="transport-type" style="margin-left: -2px">
                    <div v-for="option in options" :key="option.type" :class="[
                      'option',
                      { active: formData.method === option.type },
                    ]" @click="selectType(option.type)">
                      <div class="icon">
                        <img :src="require(`@/images/${option.icon}`)" />
                      </div>
                      <div class="title-name">
                        <div class="title">{{ option.title }}</div>
                        <div class="subtitle">{{ option.subtitle }}</div>
                      </div>
                    </div>
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="5"></a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 预计提货时间 -->
              <a-col :span="12">
                <a-form-item label="预计提货时间：" name="pickupTime">
                  <a-config-provider :locale="locale">
                    <a-date-picker v-model="formData.pickupTimeMoment" format="YYYY-MM-DD HH:mm" show-time />
                  </a-config-provider>
                  <a-config-provider :locale="locale">
                    <a-time-picker v-model="formData.pTime" placeholder="请选择" format="HH:mm" />
                  </a-config-provider>
                </a-form-item>
              </a-col>

              <!-- 预计送达时间 -->
              <a-col :span="12">
                <a-form-item label="预计送达时间：" name="signTime">
                  <a-config-provider :locale="locale">
                    <a-date-picker v-model="formData.signTime" format="YYYY-MM-DD HH:mm" show-time />
                  </a-config-provider>
                  <a-config-provider :locale="locale">
                    <a-time-picker v-model="formData.sTime" placeholder="请选择" format="HH:mm" />
                  </a-config-provider>
                </a-form-item>
              </a-col>
            </a-row>
            <hr style="
                border: none;
                border-top: 2px dotted #e6e6e6;
                margin-bottom: 24px;
              " />
            <a-row :gutter="24">
              <!-- 货名 -->
              <a-col :span="12">
                <a-form-item label="货名名称：" name="goodsId">
                  <a-input v-model="formData.goodsId" placeholder="请货名名称" />
                </a-form-item>
              </a-col>
              <a-col :span="12"> </a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 包装方式 -->
              <a-col :span="12">
                <a-form-item label="包装方式：" name="package">
                  <a-input placeholder="请输入包装方式" v-model="formData.package" />
                </a-form-item>
              </a-col>
              <!-- 件数 -->
              <a-col :span="12">
                <a-form-item label="件数：" name="number">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.number" addon-after="件" placeholder="请输入数量"
                      @change="validateNumber('number', 'numberAlert')" />
                    <a-alert v-if="alerts.numberAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <!-- 重量 -->
              <a-col :span="12">
                <a-form-item label="重量：" name="weight">
                  <div style="display: flex; flex-direction: column">
                    <a-input style="width: 306px !important" addon-after="公斤" placeholder="请输入重量"
                      v-model="formData.weight" @change="validateNumber('weight', 'weightAlerts')" />
                    <a-alert v-if="formData.weight && alerts.weightAlerts" type="error" message="输入非数字，请输入数字！"
                      show-icon />
                    <a-alert v-if="weightAlert" type="error" :message="`请填写货物重量!`" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <!-- 体积 -->
              <a-col :span="12">
                <a-form-item label="体积：" name="volume">
                  <div style="display: flex; flex-direction: column">
                    <a-input addon-after="方" placeholder="请输入体积数" v-model="formData.volume"
                      @change="validateNumber('volume', 'volumeAlerts')" />
                    <a-alert v-if="formData.volume && alerts.volumeAlerts" type="error" message="输入非数字，请输入数字！"
                      show-icon />
                    <a-alert v-if="volumeAlert" type="error" :message="`请填写货物体积!`" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 货物价值： -->
              <a-col :span="13">
                <a-form-item label="货物价值：" name="valuation">
                  <div style="display: flex; flex-direction: column">
                    <a-input style="margin-left: 6px" addon-after="元" placeholder="请输入货物价值（或保价）"
                      v-model="formData.valuation" @change="validateNumber('valuation', 'valuationAlert')" />
                    <a-alert v-if="alerts.valuationAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="11"></a-col>
            </a-row>

            <!-- <a-row :gutter="24">
             赠送保额  
            <a-col :span="18">
              <a-form-item label="赠送保额：" name="compensation">
                <a-radio-group v-model="formData.compensation">
                  <a-radio value="不赠送">不赠送</a-radio>
                  <a-radio value="赠送">赠送</a-radio>
                </a-radio-group>
                <a-input
                  addon-after="保额"
                  placeholder="请输入额度"
                  style="margin-left: 48px"
                  v-model="formData.compensationAmount"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6"></a-col>
          </a-row> -->

            <a-row :gutter="24">
              <!-- 付款方式 -->
              <a-col :span="10">
                <a-form-item label="付款方式：" name="paymentMethod">
                  <a-radio-group style="margin-right: 58px" v-model="formData.paymentMethod">
                    <a-radio :value="2">寄方付</a-radio>
                    <a-radio :value="1">收方付</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="14"></a-col>
            </a-row>
            <a-row :gutter="24">
              <!-- 电子回单 -->
              <a-col :span="10">
                <a-form-item label="电子回单：" name="isElectronicReceipt">
                  <a-radio-group style="margin-right: 72px" v-model="formData.isElectronicReceipt">
                    <a-radio :value="false">不需要</a-radio>
                    <a-radio :value="true">需要</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="14"></a-col>
            </a-row>
            <a-row :gutter="24">
              <!-- 纸质回单 -->
              <a-col :span="16">
                <a-form-item label="纸质回单：" name="isPrintReceipt">
                  <a-radio-group v-model="formData.isPrintReceipt">
                    <a-radio :value="false">不需要</a-radio>
                    <a-radio :value="true">需要</a-radio>
                  </a-radio-group>
                  <div style="font-size: 16px; color: #969998; padding-right: 54px">
                    快件25元；快递直邮；大约3天送达；
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="8"> </a-col>
            </a-row>
            <a-row :gutter="24">
              <!-- 纸质回单(快件) -->
              <a-col :span="8">
                <a-form-item label="纸质回单(快件)：" name="isPrintReceiptExpress">
                  <a-radio-group v-model="formData.isPrintReceiptExpress" style="margin-right: -12px">
                    <a-radio :value="false">不需要</a-radio>
                    <a-radio :value="true">需要</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="16"> </a-col>
            </a-row>
            <a-row :gutter="22">
              <!-- 送货进仓 -->
              <a-col :span="8">
                <a-form-item label="送货方式：" name="isDeliveryGoods">
                  <a-radio-group style="margin-right: 3px" v-model="formData.isDeliveryGoods">
                    <a-radio :value="false">自提</a-radio>
                    <a-radio :value="true">送货</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="16">
                <div style="margin-left: -12px; font-size: 16px; color: #969998">
                  服务费150元起，送货费用根据人力、搬运方式、3楼及以上有无电梯、货物价值/类型及搬运注意事项等据实收取;
                </div>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <!-- 计价方式 -->
              <a-col :span="8">
                <a-form-item label="计价方式：" name="isSystemCalculate">
                  <a-radio-group v-model="formData.isSystemCalculate" style="margin-right: -54px"
                    @change="handleChangeCalculateType">
                    <a-radio :value="true">系统计价</a-radio>
                    <a-radio :value="false">人工计价</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="16"> </a-col>
            </a-row>
            <hr style="
                border: none;
                border-top: 2px dotted #e6e6e6;
                margin-bottom: 24px;
              " />

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="系统计算价格：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.showPrice" :disabled="true" />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12"> </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="基础运费：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.freight" @change="validateNumber('freight', 'freightAlert')"
                      :disabled="formData.isSystemCalculate" />
                    <a-alert v-if="alerts.freightAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="税费：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.commission" @change="validateNumber('commission', 'commissionAlert')" />
                    <a-alert v-if="alerts.commissionAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="保险：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.insurance" @change="validateNumber('insurance', 'insuranceAlert')" />
                    <a-alert v-if="alerts.insuranceAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="装货费：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.loadingCharges" @change="
                      validateNumber('loadingCharges', 'loadingChargesAlert')
                      " />
                    <a-alert v-if="alerts.loadingChargesAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="卸货费：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.landingCharges" @change="
                      validateNumber('landingCharges', 'landingChargesAlert')
                      " />
                    <a-alert v-if="alerts.landingChargesAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="木架费：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.timberingCost" @change="
                      validateNumber('timberingCost', 'timberingCostAlert')
                      " />
                    <a-alert v-if="alerts.timberingCostAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="营销费：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.marketingExpenses" @change="
                      validateNumber(
                        'marketingExpenses',
                        'marketingExpensesAlert'
                      )
                      " />
                    <a-alert v-if="alerts.marketingExpensesAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="其它：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.otherExpenses" @change="
                      validateNumber('otherExpenses', 'otherExpensesAlert')
                      " />
                    <a-alert v-if="alerts.otherExpensesAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="提货成本：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.deliveryCost" @change="
                      validateNumber('deliveryCost', 'deliveryCostAlert')
                      " />
                    <a-alert v-if="alerts.deliveryCostAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="专线成本：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.privateLineCost" @change="
                      validateNumber(
                        'privateLineCost',
                        'privateLineCostAlert'
                      )
                      " />
                    <a-alert v-if="alerts.privateLineCostAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="运作提成：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.operatingCommission" @change="
                      validateNumber(
                        'operatingCommission',
                        'operatingCommissionAlert'
                      )
                      " />
                    <a-alert v-if="alerts.operatingCommissionAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="销售提成：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.salesCommission" @change="
                      validateNumber(
                        'salesCommission',
                        'salesCommissionAlert'
                      )
                      " />
                    <a-alert v-if="alerts.salesCommissionAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="代收货款：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.collectionFee" @change="
                      validateNumber('collectionFee', 'collectionFeeAlert')
                      " />
                    <a-alert v-if="alerts.collectionFeeAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="代收手续费：">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.collectionRatio" @change="
                      validateNumber(
                        'collectionRatio',
                        'collectionRatioAlert'
                      )
                      " />
                    <a-alert v-if="alerts.collectionRatioAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="保险成本：" name="insuranceCost">
                  <div style="display: flex; flex-direction: column">
                    <a-input v-model="formData.insuranceCost" @change="
                      validateNumber('insuranceCost', 'insuranceCostAlert')
                      " />
                    <a-alert v-if="alerts.insuranceCostAlert" type="error" message="输入非数字，请输入数字！" show-icon />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12" v-show="vShow">
                <a-form-item label="费用合计：" name="total">
                  <a-input v-model="formData.total" disabled />
                </a-form-item>
              </a-col>
            </a-row>
            <hr style="
                border: none;
                border-top: 2px dotted #e6e6e6;
                margin-bottom: 24px;
              " />
            <a-row :gutter="24" v-show="vShow">
              <a-col :span="15">
                <a-form-item label="广路单号（面单）：" name="waybill">
                  <a-input v-model="formData.waybill" />
                  <a-button class="search-normal" @click="openList" style="
                      margin-left: 16px;
                      width: 108px;
                      height: 40px;
                      border-radius: 4px;
                      border: 1px solid #14cc76;
                      font-size: 16px;
                      color: #14cc76;
                    ">查看电子单</a-button>
                </a-form-item>
              </a-col>
              <a-col :span="9"></a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 承运公司 -->
              <a-col :span="12">
                <a-form-item label="承运商：" name="generalCarrier">
                  <a-input v-model="formData.generalCarrier" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="承运单号：" name="generalCarrierNumber">
                  <a-input v-model="formData.generalCarrierNumber" />
                  <a-upload :before-upload="beforeUpload" @change="handleUpload">
                    <a-button style="
                        margin-left: 10px;
                        width: 80px;
                        height: 40px;
                        border-radius: 4px;
                        border: 1px solid #14cc76;
                        font-size: 16px;
                        color: #14cc76;
                        display: none;
                        align-items: center;
                        justify-content: center;
                      ">上传文件</a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 回单状态 -->
              <a-col :span="12">
                <a-form-item label="回单状态：" name="receiptStatus">
                  <a-select v-model="formData.receiptStatus" placeholder="请选择">
                    <a-select-option value="0">未回单</a-select-option>
                    <a-select-option value="1">已回单</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="在途信息：" name="transitInformation">
                  <a-input v-model="formData.transitInformation" />
                  <a-upload :before-upload="beforeUpload" @change="handleUpload">
                    <a-button style="
                        margin-left: 10px;
                        width: 80px;
                        height: 40px;
                        border-radius: 4px;
                        border: 1px solid #14cc76;
                        font-size: 16px;
                        color: #14cc76;
                        display: none;
                        align-items: center;
                        justify-content: center;
                      ">上传文件</a-button>
                  </a-upload>
                </a-form-item>
                <!-- <a-form-item label="回单信息：" name="receiptInfo">
                <a-input v-model="formData.receiptInfo" />
                <a-upload :before-upload="beforeUpload" @change="handleUpload">
                  <a-button
                    style="
                      margin-left: 10px;
                      width: 80px;
                      height: 40px;
                      border-radius: 4px;
                      border: 1px solid #14cc76;
                      font-size: 16px;
                      color: #14cc76;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                    >上传文件</a-button
                  >
                </a-upload>
              </a-form-item> -->
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <!-- 签收情况 -->
              <a-col :span="12">
                <a-form-item label="签收情况：" name="signCondition">
                  <a-select v-model="formData.signCondition" placeholder="请选择">
                    <a-select-option value="0">未签收</a-select-option>
                    <a-select-option value="1">已签收</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- 运作人员 -->
              <a-col :span="12">
                <a-form-item label="运作人员：" name="operationPersonnel">
                  <a-select show-search :filterOption="filterOption" :allowClear="true"
                    v-model="formData.operationPersonnel" style="width: 434px; height: 40px; flex: 1 1 0%">
                    <a-select-option v-for="item in operationUserList" :value="item.name" :key="item.name">{{ item.name
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-item label="备注：" name="remark">
                  <a-textarea style="width: 802px !important" v-model="formData.remark"
                    :auto-size="{ minRows: 3, maxRows: 5 }" />
                </a-form-item>
              </a-col>
              <!-- 物流情况  
             <a-col :span="12">
              <a-form-item label="物流情况：" name="logisticsStatus">
                <a-input v-model="formData.logisticsStatus" />
              </a-form-item>
            </a-col> -->
            </a-row>
          </a-form>
        </a-spin>
        <div :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }">
          <a-button :style="{ marginRight: '8px' }" @click="onClose">
            取消
          </a-button>
          <a-button type="primary" @click="orderUpdateOk">提交</a-button>
        </div>
      </a-drawer>
      <a-modal :style="{ zIndex: 2 }" width="1150" v-model="listShow" scrollable title="电子单详情" :ok-text="'下载'"
        :cancel-text="'取消'" @ok="listOk" @cancel="listCancel" :wrapClassName="'centered-modal'">
        <div class="form-container" ref="exportDiv">
          <img :src="require('@/images/goodsList.png')" alt="Background" class="background" />
          <div class="content">
            <!-- 寄件人信息 -->
            <span class="snum">{{ formList.waybill }}</span>
            <span class="sname">{{ formList.sendName }}</span>
            <span class="origin">{{ formList.sendProvince }}</span>
            <span class="iname">{{ formList.senderIname }}</span>
            <span class="sphone">{{ formList.sendPhone }}</span>
            <span class="sprovince">{{ formList.sProvince }}</span>
            <span class="scity">{{ formList.sCity }}</span>
            <span class="sarea">{{ formList.sDistrict }}</span>
            <span class="svillage">{{ formList.senderVillage }}</span>
            <span class="saddress">{{ formList.sendAddress }}</span>

            <!-- 收件人信息 -->
            <span class="rname">{{ formList.receiveName }}</span>
            <span class="rorigin">{{ formList.receiveCity }}</span>
            <span class="riname">{{ formList.recipientIname }}</span>
            <span class="rphone">{{ formList.receivePhone }}</span>
            <span class="rprovince">{{ formList.rProvince }}</span>
            <span class="rcity">{{ formList.rCity }}</span>
            <span class="rarea">{{ formList.rDistrict }}</span>
            <span class="rvillage">{{ formList.recipientVillage }}</span>
            <span class="raddress">{{ formList.receiveAddress }}</span>

            <!-- 货品信息 -->
            <span class="goodsname">{{ formList.goodsName }}</span>
            <span class="pack">{{ formList.goodsPack }}</span>
            <span class="amount">{{ formList.goodsAmount }}</span>
            <span class="weight">{{ formList.goodsWeight }}</span>
            <span class="volume">{{ formList.goodsVolume }}</span>

            <!-- 增值服务与费用 -->
            <span class="insure2" :style="{ left: formList.valuation ? '630px' : '679px' }">{{ formList.insure2
              }}</span>
            <span class="svalue">{{ formList.valuation }}</span>
            <span class="premium">{{ formList.insurance }}</span>
            <span class="paper1">{{ formList.isPrintReceipt }}</span>
            <span class="paper2">{{ formList.isPrintReceiptExpress }}</span>
            <span class="elec">{{ formList.isElectronicReceipt }}</span>
            <span class="remark">{{ formList.remark }}</span>
            <span class="number">{{ formList.goodsAmount }}</span>
            <span class="weights">{{ formList.goodsWeight }}</span>
            <span class="squares">{{ formList.goodsVolume }}</span>
            <span class="freight">{{ formList.total }}</span>
            <span class="serviceCharge">{{ formList.serviceCharge }}</span>
            <span class="totalcost">{{ formList.total }}</span>

            <!-- 其他信息 -->
            <span class="receive" :style="{ left: formList.paymentMethod == 2 ? '650px' : '838px' }">{{
              formList.chooseMethod }}</span>
            <span class="ssign">{{ formList.sendName }}</span>
            <span class="rsign"></span>
            <span class="syear">{{ formList.syear }}</span>
            <span class="smonth">{{ formList.smonth }}</span>
            <span class="sday">{{ formList.sday }}</span>
            <span class="ryear">{{ formList.ryear }}</span>
            <span class="rmonth">{{ formList.rmonth }}</span>
            <span class="rday">{{ formList.rday }}</span>
            <span class="merchandiser">{{ formList.merchandiser }}</span>
            <span class="destination">{{ formList.receiveCity }}</span>
            <span class="self">{{ formList.self }}</span>
            <span class="other" :style="{ top: formList.isDeliveryGoods ? '80px' : '50px' }">{{ formList.other }}</span>
          </div>
        </div>
      </a-modal>
    </div>
  </MenuRef>
</template>

<script>
import moment from "moment";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import {
  getOrderList,
  deleteOrder,
  getCompanyDropdown,
  getUserList,
  getUserListByType,
  getAddressList,
  upsertOrder,
  getSendAddress,
  getEstimatedPrice,
  exportOrderList,
} from "@/api";
import MenuRef from "./common/MenuRef";
import html2canvas from "html2canvas";
import JsPDF from "jspdf";
import Cookies from "js-cookie";
import rolePermissions from "./rolePermissions.js";

export default {
  components: {
    MenuRef,
  },
  data() {
    return {
      permissions: {},
      getShow: true,
      showColor: ["2"],
      form: this.$form.createForm(this),
      visible: false,
      startDate: null,
      endDate: null,
      companyList: [],
      userList: [],
      operationUserList: [],
      weightAlert: false,
      volumeAlert: false,
      raddStatus: false,
      saddStatus: false,
      options: [
        {
          type: 1,
          title: "零担(小件货)",
          subtitle: "限0.3T或1.5方内",
          icon: "icon1.png",
        },
        {
          type: 2,
          title: "零担(大件货)",
          subtitle: "大于1.5方，稳定时效",
          icon: "icon2.png",
        },
        // {
        //   type: 3,
        //   title: "限时达",
        //   subtitle: "稳定时效，悔必赔",
        //   icon: "icon3.png",
        // },
        {
          type: 3,
          title: "整车",
          subtitle: "专车直送，安全快捷",
          icon: "icon4.png",
        },
      ],
      alerts: {
        discountAlert: false,
        freightAlert: false,
        commissionAlert: false,
        insuranceAlert: false,
        loadingChargesAlert: false,
        landingChargesAlert: false,
        timberingCostAlert: false,
        marketingExpensesAlert: false,
        otherExpensesAlert: false,
        deliveryCostAlert: false,
        privateLineCostAlert: false,
        operatingCommissionAlert: false,
        salesCommissionAlert: false,
        collectionFeeAlert: false,
        collectionRatioAlert: false,
        insuranceCostAlert: false,
        numberAlert: false,
        volumeAlerts: false,
        weightAlerts: false,
        valuationAlert: false,
      },
      phoneAlerts: {
        phone: false,
        sendPhone: false,
        receivePhone: false,
      },
      timePicker: [],
      dateFormatList: ["YYYY-MM-DD", "YYYY-MM-DD"],
      form: {
        num: "",
        one: "",
        two: "",
        three: "",
        five: "",
        six: "",
        companyId: "",
        operationPersonnel:"",
        generalCarrierNumber:""
      },
      formNewData: {},
      formData: {
        waybill: "",
        companyId: "",
        clientLevel: "",
        discount: 1,
        userId: "",
        phone: "",
        sendAddressAll: [],
        sendName: "",
        sendPhone: "",
        sendProvince: "",
        sendCity: "",
        sendDistrict: "",
        sendAddress: "",
        receiveName: "",
        receivePhone: "",
        receiveAddressAll: [],
        receiveProvince: "",
        receiveCity: "",
        receiveDistrict: "",
        receiveAddress: "",
        method: 1,
        pickupTime: "",
        pickupTimeMoment: moment(),
        pTime: moment().startOf("d"),
        signTime: undefined,
        sTime: undefined,
        goodsId: "",
        package: "",
        number: null,
        weight: null,
        volume: null,
        valuation: null,
        loadingCharges: null,
        landingCharges: null,
        timberingCost: null,
        marketingExpenses: null,
        otherExpenses: null,
        deliveryCost: null,
        privateLineCost: null,
        operatingCommission: null,
        salesCommission: null,
        collectionFee: null,
        collectionRatio: null,
        insuranceCost: null,
        paymentMethod: 2,
        isElectronicReceipt: false,
        isUnload: false,
        unloadPrice: "",
        isPrintReceipt: false,
        isPrintReceiptExpress: false,
        printReceiptPrice: 0,
        isDeliveryGoods: false,
        isSystemCalculate: true,
        deliveryPrice: 0,
        freight: null,
        commission: null,
        insurance: null,
        generalCarrier: null,
        generalCarrierNumber: null,
        receiptStatus: "0",
        signCondition: "0",
        transitInformation: "",
        remark: "",
        showPrice: null,
        operationPersonnel: ""
      },
      addressOptions: [],
      addressSendOptions: [],
      locale: zhCN,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      indexNum: 1,
      tolInformation: [],
      columns: [
        {
          title: "序号",
          key: "index",
          align: "center",
          fixed: "left",
          width: 80,
          customRender: (text, record, index) =>
            `${(this.indexNum - 1) * this.indexNum + index + 1}`,
        },
        {
          title: "下单时间",
          align: "center",
          fixed: "left",
          width: 180,
          customRender: (text, record, index) => {
            return moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss");
          },
        },
        {
          title: "广路单号",
          align: "center",
          width: 180,
          customRender: (text, record, index) => {
            return record.waybill || "/";
          },
        },
        {
          title: "承运商单号",
          align: "center",
          width: 180,
          customRender: (text, record, index) => {
            return record.generalCarrierNumber || "/";
          },
        },
        {
          title: "承运公司",
          align: "center",
          width: 237,
          customRender: (text, record, index) => {
            return record.generalCarrier || "/";
          },
        },
        {
          title: "订单类型",
          align: "center",
          width: 95,
          customRender: (text, record, index) => {
            return record.method == 1
              ? "零担(小件货)"
              : record.method == 2
                ? "零担(大件货)"
                : "整车直送";
          },
          align: "center",
        },
        {
          title: "电销人员",
          align: "center",
          width: 103,
          customRender: (text, record, index) => {
            return record.telemarketingStaf || "/";
          },
        },
        {
          title: "运作人员",
          align: "center",
          width: 103,
          customRender: (text, record, index) => {
            return record.operationPersonnel || "/";
          },
        },
        {
          title: "客户企业",
          width: 237,
          align: "center",
          customRender: (text, record, index) => {
            let msg = "/";
            if (record.company && record.company.length > 0) {
              msg = record.company[0].name;
            }
            return msg;
          },
          align: "center",
        },
        {
          title: "客户名称",
          width: 103,
          align: "center",
          customRender: (text, record, index) => {
            return record.user && record.user.nickname
              ? record.user.nickname
              : "/";
          },
          align: "center",
        },
        {
          title: "应收金额",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.total ? "￥" + record.total : "/";
          },
          align: "center",
        },
        {
          title: "下单金额",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.orderAmount ? "￥" + record.orderAmount : "/";
          },
          align: "center",
        },
        {
          title: "发货人",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.sendName || "/";
          },
          align: "center",
        },
        {
          title: "收货人",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.receiveName || "/";
          },
          align: "center",
        },
        {
          title: "收货地址",
          align: "center",
          width: 800,
          customRender: (text, record, index) => {
            return (
              record.receiveProvince +
              record.receiveCity +
              record.receiveDistrict +
              record.receiveAddress
            );
          },
          align: "center",
        },
        {
          title: "货物名称",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.orderGoods && record.orderGoods.length > 0
              ? record.orderGoods[0].name
              : "/";
          },
          align: "center",
        },
        {
          title: "包装方式",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.orderGoods && record.orderGoods.length > 0
              ? record.orderGoods[0].package
              : "/";
          },
          align: "center",
        },
        {
          title: "件数",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.orderGoods && record.orderGoods.length > 0
              ? record.orderGoods[0].number
              : "/";
          },
          align: "center",
        },
        {
          title: "重量",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.orderGoods && record.orderGoods.length > 0
              ? record.orderGoods[0].weight
              : "/";
          },
          align: "center",
        },
        {
          title: "方数",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            return record.orderGoods && record.orderGoods.length > 0
              ? record.orderGoods[0].volume
              : "/";
          },
          align: "center",
        },
        {
          title: "回单状态",
          align: "center",
          width: 139,
          customRender: (text, record, index) => {
            let h = this.$createElement;
            let msg = record.receiptStatus == 0 ? "未回单" : "已回单";
            let color = record.receiptStatus == 0 ? "#999999" : "#313332";
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: color,
                  },
                },
                msg
              ),
            ]);
          },
          align: "center",
        },

        {
          title: "在途信息",
          align: "center",
          width: 180,
          customRender: (text, record, index) => {
            return record.transitInformation || "/";
          },
          align: "center",
        },
        {
          title: "签收情况",
          align: "center",
          fixed: "right",
          width: 90,
          customRender: (text, record, index) => {
            let h = this.$createElement;
            let msg = record.status == 3 ? "已签收" : "未签收";
            let color = record.status == 3 ? "#14CC76" : "#999999";
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: color,
                  },
                },
                msg
              ),
            ]);
          },
          align: "center",
        },
        {
          title: "时效预警",
          align: "center",
          fixed: "right",
          width: 90,
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h(
              "div",
              {
                style: { fontSize: "16px" },
              },
              [
                h("a-icon", {
                  props: {
                    type: "clock-circle",
                    style: {
                      fontSize: 18,
                    },
                  },
                }),
                h(
                  "span",
                  {
                    style: {
                      marginLeft: "8px", // 根据需要调整间距
                      color:
                        record.signCondition == 0 && record.timeLimitation <= 1
                          ? "red"
                          : "",
                    },
                  },
                  `${record.timeLimitation || 0} 天`
                ),
              ]
              // 你可以在这里添加更多样式，但在这个例子中我们直接在 a-icon 上添加了 marginRight
            );
          },
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          fixed: "right",
          width: 200,
          customRender: (text, record, index) => {
            let h = this.$createElement;
            const perms = this.permissions.waybillManagement;

            let buttons = [];

            buttons.push(
              h(
                "span",
                {
                  style: {
                    cursor: perms.canUpdate ? "pointer" : "not-allowed",
                    color: perms.canUpdate ? "#6699FF" : "#CCCCCC",
                    marginRight: "24px",
                  },
                  on: {
                    click: () => {
                      if (perms.canUpdate) {
                        this.goodsFormList = record;
                        this.showDrawer(2, record);
                      }
                    },
                  },
                },
                "更新"
              )
            );

            buttons.push(
              h(
                "span",
                {
                  style: {
                    cursor: perms.canExportWaybill ? "pointer" : "not-allowed",
                    color: perms.canExportWaybill ? "#6699FF" : "#CCCCCC",
                    marginRight: "24px",
                  },
                  on: {
                    click: () => {
                      if (perms.canExportWaybill) {
                        this.goodsFormList = record;
                        this.openList();
                      }
                    },
                  },
                },
                "面单导出"
              )
            );

            buttons.push(
              h(
                "span",
                {
                  style: {
                    cursor: perms.canDeleteWaybill ? "pointer" : "not-allowed",
                    color: perms.canDeleteWaybill ? "#FF4D4D" : "#CCCCCC",
                  },
                  on: {
                    click: () => {
                      if (perms.canDeleteWaybill) {
                        this.selectRow = [record];
                        this.deleteData();
                      }
                    },
                  },
                },
                "删除"
              )
            );

            return h("div", buttons);
          },
          align: "center",
        },
      ],
      tableHeight: 259,
      pageSize: 10,
      pagination: {
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: false, // 显示可改变每页数量
        showQuickJumper: true,
        pageSizeOptions: ["15", "20", "30", "50"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
        size: "middle",
      },
      selectRow: [],
      loading: false,
      vShow: false,
      typeNum: 1,
      listShow: false,
      formList: {
        waybill: "",
        sendName: "",
        sendAddress: "",
        senderIname: "",
        sendPhone: "",
        sendProvince: "",
        sProvince: "",
        sCity: "",
        sDistrict: "",
        senderVillage: "",
        receiveName: "",
        receiveProvince: "",
        recipientIname: "",
        receivePhone: "",
        rProvince: "",
        rCity: "",
        rDistrict: "",
        recipientVillage: "",
        receiveAddress: "",
        goodsName: "",
        goodsPack: "",
        goodsAmount: 0,
        goodsWeight: 0,
        goodsVolume: 0,
        insure2: "√",
        valuation: "5000",
        insurance: "",
        isPrintReceipt: "√",
        isPrintReceiptExpress: "√",
        isElectronicReceipt: "√",
        freight: "",
        serviceCharge: "",
        remark: "",
        total: "",
        chooseMethod: "√",
        paymentMethod: 1,
        receiveName: "",
        syear: "",
        smonth: "",
        sday: "",
        ryear: "",
        rmonth: "",
        rday: "",
        merchandiser: "",
        destination: "",
        self: "",
        other: "√",
      },
      goodsFormList: {},
      allUsers: [],
    };
  },
  methods: {
    moment,
    validateNumber(field, alertField) {
      if (isNaN(this.formData[field])) {
        this.alerts[alertField] = true;
      } else {
        this.alerts[alertField] = false;
      }
    },
    validateContact(field) {
      const value = this.formData[field];
      const mobileRegex = /^1[3456789]\d{9}$/; // 手机号正则表达式
      const telephoneRegex = /^0\d{2,3}-\d{7,8}$/; // 带区号的固定电话号码正则表达式
      if (!value) {
        this.phoneAlerts[field] = false; // 如果输入为空，不显示错误提醒
      } else if (!mobileRegex.test(value) && !telephoneRegex.test(value)) {
        this.phoneAlerts[field] = true; // 如果输入不符合手机号或电话号码格式，显示错误提醒
      } else {
        this.phoneAlerts[field] = false; // 输入符合格式，不显示错误提醒
      }
    },
    reset() {
      this.form = {
        num: "",
        one: "",
        two: "",
        three: "",
        five: "",
        six: "",
        companyId: "",
        operationPersonnel:"",
        generalCarrierNumber:""
      };
      this.onDateClear();
      this.basicsData();
    },
    companySearchSelect(id) {
      this.form.companyId = id;
    },
    companySelect(id) {
      this.formData.companyId = id;
      let data = [];
      this.allUsers.forEach((item) => {
        if (item.company) {
          if (item.company.id == id) {
            data.push(item);
          }
        }
      });

      this.companyList.forEach((item) => {
        if (item.id == id) {
          if (item.province && item.city && item.district) {
            this.formData.sendAddressAll = [
              item.province,
              item.city,
              item.district,
            ];
          }
          this.formData.sendProvince = item.province;
          this.formData.sendCity = item.city;
          this.formData.sendDistrict = item.district;
          this.formData.sendAddress = item.address;
          this.formData.telemarketingStaf = item.telemarketing;
        }
      });

      if (data.length > 0) {
        this.userList = data;
        this.formData.userId = data[0].id;
        this.userList.forEach((item) => {
          if (item.id == data[0].id) {
            this.formData.sendName = item.nickname;
            this.formData.sendPhone = item.phone;
          }
        });
      } else {
        this.userList = [];
        this.formData.userId = "";
        this.formData.phone = "";
      }
    },
    userSelect(id) {
      this.formData.userId = id;
      this.userList.forEach((item) => {
        if (item.id == id) {
          this.formData.sendName = item.nickname;
          this.formData.sendPhone = item.phone;
        }
      });
    },
    removeSuffix(str) {
      return str.replace(/省$|市$|区$|县$/, "");
    },
    openList() {
      this.formList.goodsName = "";
      this.formList.goodsPack = "";
      this.formList.goodsAmount = 0;
      this.formList.goodsWeight = 0;
      this.formList.goodsVolume = 0;
      this.formList = Object.assign({}, this.formList, this.goodsFormList);
      this.formList.sProvince = this.removeSuffix(this.formList.sendProvince);
      this.formList.sCity = this.removeSuffix(this.formList.sendCity);
      this.formList.sDistrict = this.removeSuffix(this.formList.sendDistrict);
      this.formList.rProvince = this.removeSuffix(
        this.formList.receiveProvince
      );

      this.formList.rCity = this.removeSuffix(this.formList.receiveCity);
      this.formList.rDistrict = this.removeSuffix(
        this.formList.receiveDistrict
      );
      this.formList.isPrintReceipt = this.formList.isPrintReceipt ? "√" : "";
      this.formList.isPrintReceiptExpress = this.formList.isPrintReceiptExpress
        ? "√"
        : "";
      this.formList.isElectronicReceipt = this.formList.isElectronicReceipt
        ? "√"
        : "";
      this.formList.serviceCharge =
        this.goodsFormList.landingCharges +
        this.goodsFormList.loadingCharges +
        this.goodsFormList.insurance +
        this.goodsFormList.timberingCost;

      this.formList.total =
        this.formList.total ||
        parseFloat(this.formList.loadingCharges) +
        parseFloat(this.formList.landingCharges) +
        parseFloat(this.formList.timberingCost) +
        parseFloat(this.formList.otherExpenses) +
        parseFloat(this.formList.insurance) +
        parseFloat(this.formList.freight);
      const regexs = /(\d{4})年(\d{1,2})月(\d{1,2})日/;
      const [alldate, year, month, day] =
        this.goodsFormList.pickupTime.match(regexs);
      this.formList.syear = year;
      this.formList.smonth = month;
      this.formList.sday = day;

      console.log(year, month, day, 88888888888);

      let regex = /(\d{4}年\d{1,2}月\d{1,2}日 \d{1,2}:\d{2}) - (\d{1,2}:\d{2})/;
      const dateFormat = "YYYY年M月D日 HH:mm";

      if (this.goodsFormList.signTime) {
        let matche2 = this.goodsFormList.signTime.match(regex);

        if (matche2) {
          this.goodsFormList.signTime = moment(matche2[1], dateFormat).format(
            "YYYY-MM-DD HH:mm"
          );
          this.formList.ryear = this.goodsFormList.signTime
            ? moment(this.goodsFormList.signTime).format("YYYY")
            : "";
          this.formList.rmonth = this.goodsFormList.signTime
            ? moment(this.goodsFormList.signTime).format("MM")
            : "";
          this.formList.rday = this.goodsFormList.signTime
            ? moment(this.goodsFormList.signTime).format("DD")
            : "";
        } else {
          this.formList.ryear = this.goodsFormList.signTime
            ? moment(this.goodsFormList.signTime).format("YYYY")
            : "";
          this.formList.rmonth = this.goodsFormList.signTime
            ? moment(this.goodsFormList.signTime).format("MM")
            : "";
          this.formList.rday = this.goodsFormList.signTime
            ? moment(this.goodsFormList.signTime).format("DD")
            : "";
        }
      }

      if (
        this.goodsFormList.orderGoods &&
        this.goodsFormList.orderGoods.length > 0
      ) {
        this.goodsFormList.orderGoods.forEach((item) => {
          this.formList.goodsName += item.name + "、";
          this.formList.goodsPack = item.package;
          this.formList.goodsAmount += item.number;
          this.formList.goodsWeight += item.weight;
          this.formList.goodsVolume += item.volume;
        });
      }
      this.formList.goodsName = this.formList.goodsName.slice(0, -1);
      this.listShow = true;
    },
    listOk() {
      this.exportList(
        this.formData.waybill || this.formList.waybill + "-电子单"
      );
      this.listShow = false;
    },
    exportList(title) {
      var width = 1150; // 固定宽度
      var height = 635; // 固定高度
      var canvas = document.createElement("canvas"); // 创建一个 canvas 节点
      var scale = 1; // 定义任意放大倍数 支持小数
      canvas.width = width * scale; // 定义 canvas 宽度 * 缩放
      canvas.height = height * scale; // 定义 canvas 高度 * 缩放
      canvas.style.width = width * scale + "px";
      canvas.style.height = height * scale + "px";
      canvas.getContext("2d").scale(scale, scale); // 获取 context, 设置 scale
      let opts = {
        scale: scale, // 添加的 scale 参数
        canvas: canvas, // 自定义 canvas
        logging: false, // 日志开关，便于查看 html2canvas 的内部执行流程
        width: width, // 固定宽度
        height: height, // 固定高度
        allowTaint: true,
        useCORS: true, // 【重要】开启跨域配置
      };

      html2canvas(document.querySelector(".form-container"), opts).then(
        (canvass) => {
          var imgWidth = width;
          var imgHeight = height;
          var pageData = canvass.toDataURL("image/jpeg", 1.0);
          var PDF = new JsPDF({
            orientation: "landscape",
            unit: "pt",
            format: [width, height],
          });
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          PDF.save(title + ".pdf"); // 这里是导出的文件名
        }
      );
    },
    listCancel() {
      this.listShow = false;
    },
    handleSendAddressChange(value, selectedOptions) {
      if (selectedOptions.length === 3) {
        this.saddStatus = false;
        this.formData.sendAddressAll = value;
        this.formData.sendProvince = selectedOptions[0].label;
        this.formData.sendCity = selectedOptions[1].label;
        this.formData.sendDistrict = selectedOptions[2].label;
      }
    },
    handleReceiveAddressChange(value, selectedOptions) {
      if (selectedOptions.length === 3) {
        this.raddStatus = false;
        this.formData.receiveAddressAll = value;
        this.formData.receiveProvince = selectedOptions[0].label;
        this.formData.receiveCity = selectedOptions[1].label;
        this.formData.receiveDistrict = selectedOptions[2].label;
      }
    },
    beforeUpload(file) {
      console.log(file);
      return false; // Prevent automatic upload
    },
    handleUpload(info) {
      console.log(info);
    },
    handleChangeCalculateType(e) {
      if (e.target.value) {
        this.formData.freight = this.formData.showPrice;
      }
    },
    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
    onDateClear() {
      this.startDate = null;
      this.endDate = null;
      this.timePicker = [null, null];
    },
    getStartDatePicker(date, dateString) {
      this.startDate = moment(date[0]);
      this.endDate = moment(date[1]);
    },
    selectType(type) {
      this.formData.method = type;
    },
    showDrawer(type, list) {
      this.typeNum = type;
      if (type == 1) {
        this.formData = {
          waybill: "",
          companyId: "",
          clientLevel: "",
          discount: 1,
          userId: "",
          phone: "",
          sendAddressAll: [],
          sendName: "",
          sendPhone: "",
          sendProvince: "",
          sendCity: "",
          sendDistrict: "",
          sendAddress: "",
          receiveName: "",
          receivePhone: "",
          receiveAddressAll: [],
          receiveProvince: "",
          receiveCity: "",
          receiveDistrict: "",
          receiveAddress: "",
          method: 1,
          pickupTime: "",
          pickupTimeMoment: moment(),
          pTime: moment().startOf("d"),
          signTime: undefined,
          sTime: undefined,
          goodsId: "",
          package: "",
          number: null,
          weight: null,
          volume: null,
          valuation: null,
          loadingCharges: null,
          landingCharges: null,
          timberingCost: null,
          marketingExpenses: null,
          otherExpenses: null,
          deliveryCost: null,
          privateLineCost: null,
          operatingCommission: null,
          salesCommission: null,
          paymentMethod: 2,
          isElectronicReceipt: false,
          isUnload: false,
          unloadPrice: "",
          isPrintReceipt: false,
          isPrintReceiptExpress: false,
          printReceiptPrice: 0,
          isDeliveryGoods: false,
          isSystemCalculate: true,
          deliveryPrice: 0,
          freight: null,
          commission: null,
          insurance: null,
          generalCarrier: null,
          generalCarrierNumber: null,
          receiptStatus: "0",
          signCondition: "0",
          transitInformation: "",
          //这几个发瘟不加过不了。。。
          total: 0,
          orderAmount: 0,
          isElectronicReceipt: false,
          electronicReceiptPrice: 0,
          remark: "",
          orderLogisticses: [
            {
              name: "",
              map: "",
              status: 1,
              time: "",
              orderId: "",
            },
          ],
          showPrice: 0,
          operationPersonnel: ""
        };
        this.vShow = false;
      } else {
        this.formData = list;
        let regex =
          /(\d{4}年\d{1,2}月\d{1,2}日 \d{1,2}:\d{2}) - (\d{1,2}:\d{2})/;
        const dateFormat = "YYYY年M月D日 HH:mm";
        this.vShow = true;

        if (list.orderGoods && list.orderGoods.length > 0) {
          this.formData.goodsId = list.orderGoods[0].name;
          this.formData.package = list.orderGoods[0].package;
          this.formData.number = list.orderGoods[0].number;
          this.formData.weight = list.orderGoods[0].weight;
          this.formData.volume = list.orderGoods[0].volume;
        }
        this.formData.isPrintReceiptExpress = list.isPrintReceiptExpress
          ? true
          : false;
        this.formData.companyId =
          list.company && list.company.length > 0 ? list.company[0].id : "";
        this.formData.clientLevel = list.clientLevel || "";
        this.formData.phone = list.phone || "";

        if (list.company && list.company.length > 0) {
          let lists = [];
          this.allUsers.forEach((item) => {
            if (item.company) {
              if (item.company.id == list.company[0].id) {
                lists.push(item);
              }
            }
          });
          this.userList = lists;
        }

        this.formData.userId = list.user ? list.user.id : "";

        if (list.pickupTime) {
          let matche1 = list.pickupTime.match(regex);
          if (matche1) {
            this.formData.pTime = moment(matche1[2], "HH:00");
            this.formData.pickupTimeMoment = moment(matche1[1], dateFormat).format(
              "YYYY-MM-DD HH:mm"
            );
          } else {
            this.formData.pTime = undefined;
            this.formData.pickupTime = undefined;
            this.formData.pickupTimeMoment = undefined;
          }
        } else {
          this.formData.pTime = undefined;
          this.formData.pickupTime = undefined;
          this.formData.pickupTimeMoment = undefined;
        }

        if (list.signTime) {
          let matche2 = list.signTime.match(regex);
          if (matche2) {
            this.formData.sTime = moment(matche2[2], "HH:00");
            this.formData.signTime = moment(matche2[1], dateFormat).format(
              "YYYY-MM-DD HH:mm"
            );
          }
        }
        if (list.sendProvince && list.sendCity && list.sendDistrict) {
          this.formData.sendAddressAll = [
            list.sendProvince,
            list.sendCity,
            list.sendDistrict,
          ];
        }

        this.formData.total =
          parseFloat(this.formData.loadingCharges || 0) +
          parseFloat(this.formData.landingCharges || 0) +
          parseFloat(this.formData.timberingCost || 0) +
          parseFloat(this.formData.otherExpenses || 0) +
          parseFloat(this.formData.insurance || 0) +
          parseFloat(this.formData.freight || 0);
        this.formData.receivePhone = list.receivePhone;
        this.formData.receiveAddressAll = [
          list.receiveProvince,
          list.receiveCity,
          list.receiveDistrict,
        ];
        this.formData.showPrice = this.formData.freight;
        this.formData = { ...this.formData };
      }

      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    exportData() {
      let params = {};

      params = {
        header: [
          "订单编号",
          "下单时间",
          "客户公司",
          "客户名称",
          "客户等级",
          "折扣",
          "联系电话",
          "寄件人姓名",
          "寄件人电话",
          "寄件人省份",
          "寄件人城市",
          "寄件人区域",
          "寄件人详细地址",
          "收件人姓名",
          "收件人电话",
          "收件人省份",
          "收件人城市",
          "收件人区域",
          "收件人详细地址",
          "预计提货时间",
          "签收时间",
          "运输类型",
          "货名名称",
          "包装方式",
          "件数",
          "重量",
          "体积",
          "货物价值",
          "付款方式",
          "电子回单",
          "纸质回单",
          "送货方式",
          "基础运费",
          "税费",
          "保险",
          "装货费",
          "卸货费",
          "木架费",
          "营销费",
          "其它",
          "提货成本",
          "专线成本",
          "运作提成",
          "销售提成",
          "代付费用",
          "代付比例",
          "保险成本",
          "承运商",
          "承运单号",
          "回单状态",
          "在途信息",
          "签收情况",
          "运作人员",
          "备注",
          "电销人员",
          "代收货款"
        ],
        headervalues: [
          "waybill",
          "createdAt",
          "company[0]name",
          "user[]nickname",
          "clientLevel",
          "discount",
          "phone",
          "sendName",
          "sendPhone",
          "sendProvince",
          "sendCity",
          "sendDistrict",
          "sendAddress",
          "receiveName",
          "receivePhone",
          "receiveProvince",
          "receiveCity",
          "receiveDistrict",
          "receiveAddress",
          "pickupTime",
          "signTime",
          "method",
          "orderGoods[0]name",
          "orderGoods[0]package",
          "orderGoods[0]number",
          "orderGoods[0]weight",
          "orderGoods[0]volume",
          "valuation",
          "paymentMethod",
          "isElectronicReceipt",
          "isPrintReceipt",
          "isDeliveryGoods",
          "freight",
          "commission",
          "insurance",
          "loadingCharges",
          "landingCharges",
          "timberingCost",
          "marketingExpenses",
          "otherExpenses",
          "deliveryCost",
          "privateLineCost",
          "operatingCommission",
          "salesCommission",
          "collectionFee",
          "collectionRatio",
          "insuranceCost",
          "generalCarrier",
          "generalCarrierNumber",
          "receiptStatus",
          "transitInformation",
          "signCondition",
          "operationPersonnel",
          "remark",
          "telemarketingStaf",
          "collectionFee"
        ],
        name: this.form.one,
        waybill: this.form.num,
        veneer: this.form.two,
        telemarketingStaf: this.form.three,
        status: this.form.five == 1 ? [1,2,4] : this.form.five,
        generalCarrier: this.form.six,
        startTime: this.startDate ? moment(this.startDate).startOf('d').format("YYYY-MM-DD HH:mm:ss") : null,
        endTime: this.endDate ? moment(this.endDate).endOf('d').format("YYYY-MM-DD HH:mm:ss"): null,
        timeSearch: this.startDate && this.endDate ? "createdAt" : null,
        "company.id": this.form.companyId,
        operationPersonnel:this.form.operationPersonnel,
        generalCarrierNumber:this.form.generalCarrierNumber
      };

      exportOrderList({ ...params }).then((data) => {
        if (!data || data.size <= 0) {
          this.$Message.error("没有数据导出失败");
          return;
        }

        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute(
          "download",
          `${moment().format("YYYY-MM-DD")}-订单数据.xlsx`
        );

        document.body.appendChild(link);
        link.click();
      });
    },
    orderUpdateOk() {
      this.weightAlert = false;
      this.volumeAlert = false;
      this.raddStatus = false;
      this.saddStatus = false;

      let conditions = {
        weight: !!this.formData.weight,
        volume: !!this.formData.volume,
        sendAddress: this.formData.sendAddressAll.length === 3,
        receiveAddress: this.formData.receiveAddressAll.length === 3,
      };

      console.log('sssss', this.formData.sendAddressAll);

      let invalidConditions = Object.keys(conditions).filter(
        (key) => !conditions[key]
      );

      // 提示未填写的项
      this.weightAlert = invalidConditions.includes("weight");
      this.volumeAlert = invalidConditions.includes("volume");
      this.saddStatus = invalidConditions.includes("sendAddress");
      this.raddStatus = invalidConditions.includes("receiveAddress");

      if (invalidConditions.length !== 0) {
        this.$Message.error("存在必填参数未填写！");
        return;
      }

      //非数字验证
      const fields = [
        { field: "discount", alertField: "discountAlert" },
        { field: "freight", alertField: "freightAlert" },
        { field: "commission", alertField: "commissionAlert" },
        { field: "insurance", alertField: "insuranceAlert" },
        { field: "loadingCharges", alertField: "loadingChargesAlert" },
        { field: "timberingCost", alertField: "timberingCostAlert" },
        { field: "marketingExpenses", alertField: "marketingExpensesAlert" },
        { field: "otherExpenses", alertField: "otherExpensesAlert" },
        { field: "deliveryCost", alertField: "deliveryCostAlert" },
        { field: "privateLineCost", alertField: "privateLineCostAlert" },
        {
          field: "operatingCommission",
          alertField: "operatingCommissionAlert",
        },
        { field: "salesCommission", alertField: "salesCommissionAlert" },
        { field: "collectionFee", alertField: "collectionFeeAlert" },
        { field: "collectionRatio", alertField: "collectionRatioAlert" },
        { field: "insuranceCost", alertField: "insuranceCostAlert" },
        { field: "number", alertField: "numberAlert" },
        { field: "weight", alertField: "weightAlerts" },
        { field: "volume", alertField: "volumeAlerts" },
        { field: "valuation", alertField: "valuationAlert" },
      ];

      let status = true;

      fields.forEach(({ field, alertField }) => {
        this.validateNumber(field, alertField);
      });

      for (let key in this.alerts) {
        if (this.alerts[key]) {
          status = false;
          break;
        }
      }

      if (!status) {
        this.$Message.error("数字参数填写了非数字，请检查！");
        return;
      }

      this.formData.user = { id: "", nickname: "" };
      this.formData.orderGoods = [
        {
          name: "",
          package: "",
          number: "",
          weight: "",
          volume: "",
        },
      ];
      this.formData.user.id = this.formData.userId;
      if (this.formData.userId) {
        this.userList.forEach((item) => {
          if (item.id == this.formData.userId) {
            this.formData.user.nickname = item.nickname;
          }
        });
      }

      // if(this.formData.companyId){
      //   this.companyList
      // }

      this.formData.orderGoods[0].name = this.formData.goodsId;
      this.formData.orderGoods[0].package = this.formData.package;
      this.formData.orderGoods[0].number = this.formData.number;
      this.formData.orderGoods[0].weight = this.formData.weight;
      this.formData.orderGoods[0].volume = this.formData.volume;
      if (this.typeNum == 2) {
        this.formData.orderGoods[0].orderId = this.formData.id;
      }
      if (this.formData.signCondition == 1) {
        this.formData.status = 3;
      }

      this.formData.unloadPrice = this.formData.isUnload
        ? this.formData.unloadPrice
        : null;
      this.formData.isPrintReceipt = this.formData.isPrintReceipt
        ? true
        : false;
      this.formData.isPrintReceiptExpress = this.formData.isPrintReceiptExpress
        ? true
        : false;
      this.formData.printReceiptPrice =
        this.formData.isPrintReceipt == 2 ? 25 : null;
      this.formData.deliveryPrice = this.formData.isDeliveryGoods ? 150 : null;

      this.formData.pickupTimeMoment = this.formData.pickupTimeMoment
        ? moment(this.formData.pickupTimeMoment).toISOString()
        : moment().toISOString();
      this.formData.signTime = this.formData.signTime
        ? moment(this.formData.signTime).toISOString()
        : moment().toISOString();

      if (this.typeNum == 1) {
        if (this.formData.pickupTimeMoment) {

          this.formData.pickupTime =
            moment(this.formData.pickupTimeMoment).format("lll") +
            " - " +
            moment(this.formData.pTime).format("HH:mm");
        } else {
          this.$Message.error("请先填写预计提货时间！");
          return;
        }
        this.formData.signTime = undefined;
        this.formData.total =
          parseFloat(this.formData.loadingCharges || 0) +
          parseFloat(this.formData.landingCharges || 0) +
          parseFloat(this.formData.timberingCost || 0) +
          parseFloat(this.formData.otherExpenses || 0) +
          parseFloat(this.formData.insurance || 0) +
          parseFloat(this.formData.freight || 0);
        delete this.formData.waybill;
        delete this.formData.id;
      } else {
        if (this.formData.pickupTimeMoment) {
          this.formData.pickupTime =
            moment(this.formData.pickupTimeMoment).format("lll") +
            " - " +
            moment(this.formData.pTime).format("HH:mm");
        } else {
          this.$Message.error("请先填写预计提货时间！");
          return;
        }
        if (this.formData.signTime) {
          this.formData.signTime =
            moment(this.formData.signTime).format("lll") +
            " - " +
            moment(this.formData.sTime).format("HH:mm");
        }
      }
      for (let item in this.formData) {
        if (this.formData[item] === "" && this.formData[item] !== 0) {
          this.formData[item] = null;
        }
      }

      this.formNewData = { ...this.formData };

      delete this.formData.companyId;
      delete this.formData.phone;
      delete this.formData.userId;
      delete this.formData.sendAddressAll;
      delete this.formData.receiveAddressAll;
      delete this.formData.number;
      delete this.formData.weight;
      delete this.formData.volume;
      delete this.formData.goodsId;
      delete this.formData.pTime;
      delete this.formData.pickupTimeMoment;
      delete this.formData.sTime;

      this.saveData(this.formData);
    },
    async saveData(params) {
      params.isCalucateCommission = 1;
      this.loading = true;
      await upsertOrder(params).then((res) => {
        if (res.statusCode == 200) {
          this.$Message.success("数据保存成功！");
          this.basicsData();
        } else {
          this.formData = { ...this.formNewData };
          this.loading = false;
          this.$Message.error("数据保存失败！");
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    customRow(record, index) {
      return {
        style: {
          // 字体颜色
          //color: "#cceaff",
          // 行背景色
          // "background-color": "#2a3347",
          cursor: "pointer",
        },
        on: {
          // 鼠标单击行
          click: (event) => {
            // this.taskCheckData(record);
          },
        },
      };
    },
    deleteData() {
      if (this.selectRow.length > 0) {
        let list = [];
        this.selectRow.forEach((item) => {
          list.push({ id: item.id });
        });
        this.$Modal.confirm({
          title: "操作提醒！！！",
          content: "您确定将该行删除么？",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            deleteOrder(list).then((res) => {
              if (res.statusCode == 200) {
                this.$Message.success("数据删除成功！");
                this.basicsData();
              } else {
                this.$Message.error("数据删除失败！");
              }
            });
          },
          onCancel: () => {
            this.$message.info("您已取消操作！");
          },
        });
      } else {
        this.$Message.warning("请选择所要删除的数据行！");
      }
    },
    basicsData() {
      getOrderList({
        page: this.pagination.pageNo,
        size: this.pagination.pageSize,
        name: this.form.one,
        waybill: this.form.num,
        veneer: this.form.two,
        telemarketingStaf: this.form.three,
        status: this.form.five == 1 ? [1,2,4] : this.form.five,
        generalCarrier: this.form.six,
        startTime: this.startDate ? moment(this.startDate).startOf('d').format("YYYY-MM-DD HH:mm:ss") : null,
        endTime: this.endDate ? moment(this.endDate).endOf('d').format("YYYY-MM-DD HH:mm:ss"): null,
        timeSearch: this.startDate && this.endDate ? "createdAt" : null,
        isCalucateCommission: 1,
        companyId: this.form.companyId,
        operationPersonnel:this.form.operationPersonnel,
        generalCarrierNumber:this.form.generalCarrierNumber
      }).then((res) => {
        if (res.data) {
          this.visible = false;
          this.loading = false;
          this.tolInformation = res.data.list;
          this.dataCount = res.data.total;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = this.dataCount;
        }
      });
    },
    async onPageChange(page) {
      this.pageNum = page;
      this.pagination.pageNo = page;
      this.pagination.current = page;
      await this.basicsData();
    },
    searchData() {
      this.basicsData();
    },
    getCompanys() {
      getCompanyDropdown().then((res) => {
        if (res.data.list.length > 0) {
          this.companyList = res.data.list;
        }
      });
    },
    getOperationUsers() {
      getUserList({ type: 2, role: [5, 6] }).then((res) => {
        if (res.data.list.length > 0) {
          this.operationUserList = res.data.list.map(item => {
            return { ...item, name: item.nickname || item.username };
          });
        }
      });
    },
    getCustomList() {
      getUserListByType().then((res) => {
        if (res.data.list.length > 0) {
          this.userList = res.data.list;
          this.allUsers = res.data.list;
        }
      });
    },
    getAddress() {
      getAddressList().then((res) => {
        if (res.data.list.length > 0) {
          this.addressOptions = this.transformAllAddressData(res.data.list);
        }
      });
    },
    getSendAddressList() {
      getSendAddress().then((res) => {
        if (res.data.list.length > 0) {
          this.addressSendOptions = this.transformAddressData(res.data.list);
        }
      });
    },
    transformAllAddressData(data) {
      return data.map((province) => ({
        value: province.name,
        label: province.name,
        children: province.city.map((city) => ({
          value: city.name,
          label: city.name,
          children: city.area.map((area) => ({
            value: area,
            label: area,
          })),
        })),
      }));
    },
    transformAddressData(data) {
      const addressMap = new Map();

      data.forEach((item) => {
        const { province, city, district } = item;
        const key = `${province}-${city}`;

        if (!addressMap.has(key)) {
          addressMap.set(key, {
            province: province,
            city: city,
            districts: new Set(),
          });
        }

        addressMap.get(key).districts.add(district);
      });

      const addressOptions = [];

      addressMap.forEach((value, key) => {
        const [province, city] = key.split("-");
        const cityObj = {
          value: city,
          label: city,
          children: Array.from(value.districts).map((district) => ({
            value: district,
            label: district,
          })),
        };

        let provinceObj = addressOptions.find(
          (item) => item.value === province
        );

        if (!provinceObj) {
          provinceObj = {
            value: province,
            label: province,
            children: [],
          };
          addressOptions.push(provinceObj);
        }

        provinceObj.children.push(cityObj);
      });

      return addressOptions;
    },
    getBasicPrice() {
      let params = {
        province: this.formData.receiveProvince,
        city: this.formData.receiveCity,
        district: this.formData.receiveDistrict,
        weight: this.formData.weight,
        volume: this.formData.volume,
        sendProvince: this.formData.sendProvince,
        sendCity: this.formData.sendCity,
        sendDistrict: this.formData.sendDistrict,
      };
      getEstimatedPrice(params).then((res) => {
        if (res.statusCode == 200) {
          if (this.formData.isSystemCalculate) {
            this.formData.freight = res.data.totalPrice;
          }
          this.formData.showPrice = res.data.totalPrice;
        }
      });
    },
    calculateBasicPrice() {
      if (
        this.formData.weight &&
        this.formData.volume &&
        this.formData.sendAddressAll.length === 3 &&
        this.formData.receiveAddressAll.length === 3
      ) {
        this.getBasicPrice();
      }
      if (this.formData.weight) {
        this.weightAlert = false;
      }
      if (this.formData.volume) {
        this.volumeAlert = false;
      }
    },
    getTotalPrice() {
      this.formData.total =
        parseFloat(this.formData.loadingCharges || 0) +
        parseFloat(this.formData.landingCharges || 0) +
        parseFloat(this.formData.timberingCost || 0) +
        parseFloat(this.formData.otherExpenses || 0) +
        parseFloat(this.formData.insurance || 0) +
        parseFloat(this.formData.freight || 0);
    },
  },
  mounted() {
    let roleId = Cookies.get("roleId");
    this.permissions = rolePermissions[roleId];
    this.getCompanys();
    this.getOperationUsers();
    this.getCustomList();
    this.getSendAddressList();
    this.getAddress();
    this.basicsData();
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
        onSelect: (record, selected, selectedRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
      };
    },
  },
  watch: {
    // 表格高度自适应
    tolInformation: function (newVal, oldVal) {
      if (newVal.length == 0) {
        document.getElementsByClassName(
          "ant-spin-nested-loading"
        )[0].style.height = 40 + "px";
      } else {
        if (newVal.length != this.pageSize) {
          document.getElementsByTagName("table")[0].style.height = 0 + "px";
        } else {
          document.getElementsByClassName(
            "ant-spin-nested-loading"
          )[0].style.height = 100 + "%";
          document.getElementsByTagName("table")[0].style.height = 100 + "%";
        }
      }
    },
    "formData.weight": "calculateBasicPrice",
    "formData.volume": "calculateBasicPrice",
    "formData.sendAddressAll": "calculateBasicPrice",
    "formData.receiveAddressAll": "calculateBasicPrice",
    "formData.loadingCharges": "getTotalPrice",
    "formData.landingCharges": "getTotalPrice",
    "formData.timberingCost": "getTotalPrice",
    "formData.otherExpenses": "getTotalPrice",
    "formData.insurance": "getTotalPrice",
    "formData.freight": "getTotalPrice",
  },
};
</script>

<style lang="less">
.record {
  height: 100%;
  width: 100%;

  .search-btn {
    background: #14cc76;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    border-color: #14cc76;
    width: 80px;
    height: 40px;
  }

  .search-btn:hover,
  .search-btn:active,
  .search-btn:focus {
    background: #14cc76;
    border-radius: 4px;
    color: #ffffff;
    border-color: #14cc76;
  }

  .search-normal {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #969998;
    border-color: #e3e6e4;
    width: 80px;
    height: 40px;
  }

  .search-normal:hover,
  .search-normal:active,
  .search-normal:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-delete {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ff6b4d;
    border-color: #ff6b4d;
    width: 80px;
    height: 40px;
  }

  .search-delete:hover,
  .search-delete:active,
  .search-delete:focus {
    background: transparent;
    border-radius: 4px;
    color: #ff6b4d;
    border-color: #ff6b4d;
  }

  .search-cond {
    width: 100%;
    height: 250px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px;

    .search-input {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .search-item {
        width: calc(100% / 3);
        display: flex;
        align-items: center;

        .tol-title {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #313332;
          line-height: 22px;
          font-style: normal;
          margin-right: 10px;
        }
      }
    }

    .search-button {
      margin-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;

      .btn-cond {
        width: calc(100% / 3);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }

  .record-box {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;

    .title {
      display: block;
      border-bottom: solid 1px #384057;
      padding-bottom: 10px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M;
      line-height: 28px;
      text-align: left;
    }

    .record-view {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
      width: 100%;
      height: 42px;

      .tol-item {
        display: flex;
        align-items: center;

        .tol-add {
          margin-left: 20px;
        }

        .tol-title {
          margin-right: 6px;
          overflow-wrap: break-word;
          color: rgba(207, 214, 230, 1);
          font-size: 16px;
          font-family: Roboto-Medium;
        }

        .Select-style {
          width: 336px;
          height: 40px;
        }
      }
    }

    .record-table {
      height: calc(~"100% - 182px");
      padding-top: 4px;

      // 表格
      .record-table {
        height: 100%;

        .ant-checkbox-inner {
          background-color: transparent;
          border-color: rgba(132, 161, 219, 1);
        }

        //  点击时选框样式
        .ant-checkbox-wrapper-checked {
          .ant-checkbox-checked {
            background: #3384ff;
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.transport-type {
  display: flex;
  width: 100%;
  margin-right: -16px;
}

.option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 184px;
  height: 73px;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  margin: 0 10px;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.option.active {
  box-shadow: 0px 1px 8px 0px rgba(20, 204, 118, 0.3),
    inset 0px 0px 6px 0px rgba(20, 204, 118, 0.3);
  border-radius: 4px;
  border: 1px solid #14cc76;
}

.icon {
  margin-right: 6px;
  margin-bottom: 14px;
}

.title {
  font-size: 16px;
  color: #313332;
  font-weight: bold;
}

.subtitle {
  font-weight: 400;
  font-size: 12px;
  color: #969998;
}

/deep/.ant-select-selection--single {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/.ant-select-selection--multiple .ant-select-selection__rendered {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/.ant-btn {
  width: 80px;
  height: 40px;
  font-size: 16px;
}

/deep/.ant-form-item {
  display: flex;
  align-items: center;
}

/deep/.ant-input {
  width: 304px !important;
  height: 40px !important;
}

/deep/.ant-select {
  width: 304px !important;
  height: 40px !important;
}

/deep/.ant-cascader-picker {
  width: 304px !important;
  height: 40px !important;
}

/deep/.ant-input-group {
  width: 304px !important;
  height: 40px !important;
}

/deep/.ant-form-item {
  justify-content: flex-end;
}

/deep/.ant-form-item-children {
  display: flex;
}

/deep/ .ant-table-thead {
  background: #f0f0f0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #313332;
}

/deep/.ant-table-small>.ant-table-content>.ant-table-body {
  margin: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #313332;
  line-height: 22px;
}

/deep/ .ant-checkbox-wrapper-checked .ant-checkbox-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-inner {
  border: 1px solid #14cc76;
}

/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background: #14cc76;
}

/deep/ .ant-checkbox-checked::after {
  border: 1px solid #14cc76;
}

/deep/ .ant-spin-nested-loading {
  height: unset !important;
}

/deep/.ant-radio-group {
  display: flex;
  align-items: center;
}

/deep/.ant-modal {
  width: 1200px;
}

/deep/.ant-form-vertical .ant-form-item-label {
  padding: 0 !important;
}

/deep/.ant-calendar-picker {
  width: 214px !important;
}

/deep/.ant-time-picker {
  width: 90px;
  height: 40px;
}

/deep/.ant-time-picker-input {
  width: 90px;
  height: 40px;
}

/deep/.ant-select-search__field__mirror {
  opacity: 1;
}
</style>
<style scoped>
.time-style .ant-input {
  width: 434px !important;
  height: 40px !important;
}

.form-container {
  position: relative;
  height: 100%;
}

.background {
  width: 1150px;
  height: 635px;
}

.content {
  top: 0;
  left: 0;
  font-size: 16px;
  color: #000;
}

/* 定位所有的字段 */
.snum {
  position: absolute;
  top: 90px;
  left: 484px;
  letter-spacing: 7px;
  font-size: 19px;
  color: #000;
  font-weight: 500;
}

.sname {
  position: absolute;
  top: 156px;
  left: 165px;
}

.origin {
  position: absolute;
  top: 156px;
  left: 375px;
}

.iname {
  position: absolute;
  top: 195px;
  left: 150px;
}

.sphone {
  position: absolute;
  top: 196px;
  left: 390px;
}

.sprovince {
  position: absolute;
  top: 230px;
  left: 150px;
}

.scity {
  position: absolute;
  top: 230px;
  left: 220px;
}

.sarea {
  position: absolute;
  top: 230px;
  left: 290px;
}

.svillage {
  position: absolute;
  top: 230px;
  left: 375px;
}

.saddress {
  position: absolute;
  top: 255px;
  left: 90px;
  width: 430px;
  font-size: 16px;
}

.rname {
  position: absolute;
  top: 333px;
  left: 168px;
}

.rorigin {
  position: absolute;
  top: 333px;
  left: 380px;
}

.riname {
  position: absolute;
  top: 370px;
  left: 155px;
}

.rphone {
  position: absolute;
  top: 371px;
  left: 390px;
}

.rprovince {
  position: absolute;
  top: 412px;
  left: 150px;
}

.rcity {
  position: absolute;
  top: 412px;
  left: 220px;
}

.rarea {
  position: absolute;
  top: 412px;
  left: 290px;
}

.rvillage {
  position: absolute;
  top: 412px;
  left: 375px;
}

.raddress {
  position: absolute;
  top: 435px;
  left: 90px;
  width: 430px;
  font-size: 16px;
}

.number {
  position: absolute;
  top: 336px;
  left: 582px;
}

.weights {
  position: absolute;
  top: 336px;
  left: 750px;
}

.squares {
  position: absolute;
  top: 336px;
  left: 950px;
}

.goodsname {
  position: absolute;
  top: 514px;
  left: 150px;
}

.pack {
  position: absolute;
  top: 514px;
  left: 366px;
}

.amount {
  position: absolute;
  top: 562px;
  left: 125px;
}

.weight {
  position: absolute;
  top: 562px;
  left: 305px;
}

.volume {
  position: absolute;
  top: 562px;
  left: 460px;
}

.insurel {
  position: absolute;
  top: 660px;
  left: 100px;
}

.insure2 {
  position: absolute;
  top: 161px;
}

.svalue {
  position: absolute;
  top: 161px;
  left: 760px;
}

.premium {
  position: absolute;
  top: 161px;
  left: 945px;
}

.paper1 {
  position: absolute;
  top: 209px;
  left: 548px;
}

.paper2 {
  position: absolute;
  top: 209px;
  left: 720px;
}

.elec {
  position: absolute;
  top: 209px;
  left: 876px;
}

.remark {
  position: absolute;
  top: 259px;
  left: 585px;
  width: 470px;
}

.freight {
  position: absolute;
  top: 388px;
  left: 580px;
}

.serviceCharge {
  position: absolute;
  top: 388px;
  left: 750px;
}

.totalcost {
  position: absolute;
  top: 388px;
  left: 925px;
}

.send {
  position: absolute;
  top: 1020px;
  left: 100px;
}

.receive {
  position: absolute;
  top: 447px;
}

.ssign {
  position: absolute;
  top: 517px;
  left: 620px;
}

.rsign {
  position: absolute;
  top: 517px;
  left: 870px;
}

.syear {
  position: absolute;
  top: 566px;
  left: 574px;
  font-size: 16px;
}

.smonth {
  position: absolute;
  top: 566px;
  left: 632px;
  font-size: 16px;
}

.sday {
  position: absolute;
  top: 566px;
  left: 674px;
  font-size: 16px;
}

.ryear {
  position: absolute;
  top: 566px;
  left: 825px;
  font-size: 16px;
}

.rmonth {
  position: absolute;
  top: 566px;
  left: 881px;
  font-size: 16px;
}

.rday {
  position: absolute;
  top: 566px;
  left: 923px;
  font-size: 16px;
}

.merchandiser {
  position: absolute;
  top: 20px;
  left: 795px;
}

.destination {
  position: absolute;
  top: 65px;
  left: 755px;
}

.self {
  position: absolute;
  top: 1300px;
  left: 100px;
}

.other {
  position: absolute;
  top: 50px;
  left: 973px;
}
</style>
